'use client'

import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import { AggregatesModelWithValues, AggregatesValue } from '~types/search'
import './aggregateStyles.css'
import aggregatesComponents from './aggregatesComponents'

export interface ContentProps {
  aggregate: AggregatesModelWithValues
  value: string[] | { gte: number; lte: number } | boolean[]
  onChange: ((value: string[]) => void) &
    ((value: string) => void) &
    ((value: { gte: number; lte: number }) => void)
  currencyLocale?: ClientModel['currencyLocale']
  currencyFormat?: ClientModel['currencyFormat']
}

const Content = ({
  aggregate,
  value,
  valueListener,
  currencyLocale,
  currencyFormat,
  agregateLabel,
}: {
  aggregate: AggregatesModelWithValues
  value: string[] | { gte: number; lte: number } | boolean[]
  valueListener: (filter: string, value: AggregatesValue) => void
  currencyLocale?: ClientModel['currencyLocale']
  currencyFormat?: ClientModel['currencyFormat']
  agregateLabel?: string
}) => {
  const Component = aggregatesComponents[aggregate.name]
  const onChange = (filter: string, value: AggregatesValue) => {
    valueListener(filter, value)
  }
  return (
    <Component
      buckets={aggregate.buckets}
      defaultValue={value}
      onChange={onChange}
      currencyLocale={currencyLocale}
      currencyFormat={currencyFormat}
      agregateLabel={agregateLabel}
    />
  )
}

export default Content
